import { transformMuiThemeToConcordeTheme } from '@epilot/concorde-elements'
import { useMemo } from 'react'

import { transformJourneyTheme } from '../components/JourneyPage/utils'
import { selectDarkMode, selectDesign } from '../store/selectors/runtime'

import { useAppStoreSelector } from './useAppStoreSelector'
import { useDarkModeInitialization } from './useDarkMode'

export const useTheme = () => {
  const design = useAppStoreSelector(selectDesign)
  const darkMode = useAppStoreSelector(selectDarkMode)

  useDarkModeInitialization()

  return useMemo(() => {
    const concordeTheme = transformMuiThemeToConcordeTheme(
      transformJourneyTheme(design?.theme)
    )

    // Use the design tokens as they are - the action already updates them
    return { concordeTheme, designTokens: design?.designTokens, darkMode }
  }, [design, darkMode])
}
